import { render, staticRenderFns } from "./InstagramIntegrationsModal.vue?vue&type=template&id=3c1221fe"
import script from "./InstagramIntegrationsModal.vue?vue&type=script&lang=js"
export * from "./InstagramIntegrationsModal.vue?vue&type=script&lang=js"
import style0 from "./InstagramIntegrationsModal.vue?vue&type=style&index=0&id=3c1221fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports